import type { SupplyLight, SupplySummary } from '@wwf/sdk';
import { useRecordContext } from 'react-admin';
import { SupplyAvatar } from '@app/supply/show/SupplyAvatar';

export const SupplyListAvatar = () => {
    const record = useRecordContext<SupplyLight | SupplySummary>();

    return (
        <SupplyAvatar
            variant="md"
            record={record}
            title={record?.name ?? undefined}
            aria-label={record?.name ?? 'Supply'}
        />
    );
};
